import React from "react"
import api from "src/api"
import { getPartnerDiscountType } from "src/utils"

export function useGetData() {
  const [dataDiscounts, setDataDiscounts] = React.useState([])
  const [discountTypeOptions, setDiscountTypeOptions] = React.useState([])

  const [isLoading, setIsLoading] = React.useState(false)
  const [pagination, setPagination] = React.useState(null)

  const [filterState, setFilterState] = React.useState(null)

  React.useEffect(() => {
    getItems()
    getDiscountTypes()
  }, [])

  function getDiscountTypes() {
    const data = getPartnerDiscountType()
    setDiscountTypeOptions(data)
  }

  const getItems = async (page = 1, countOnPage = 20, filters) => {
    setIsLoading(true)
    try {
      const { data } = await api.get(`partner-discounts?page=${page}&countOnPage=${countOnPage}${filters}`, {useV2Api: true})
      const items = formattedItems(data.items)
      setPagination({
        current: data.pagination.currentPage,
        pageSize: data.pagination.countOnPage,
        total: data.pagination.total,
      })
      setDataDiscounts(items)
    } catch (e) {
      console.error("Error: ", e)
    }

    setIsLoading(false)
  }

  function handleTableChange(paginationData) {
    if (filterState) {
      handleSearchTable(filterState, paginationData)
    } else {
      getItems(paginationData.current, paginationData.pageSize)
    }
  }

  function handleSearchTable(filters, paginationSet = null) {
    let filters_str = ""
    let count = 0;
    for (let [key, value] of Object.entries(filters)) {
      if(value && value !== "") {
        switch (key) {
          case "recipient_email":
            filters_str += `&filters[${count}][t]=iL&filters[${count}][f]=recipient_email&filters[${count}][v]=${value}`
            break;
        }
        count++
      }
    }
    if (filters_str && filters_str !== "") {
      setFilterState(filters)
    } else {
      setFilterState(null)
    }
    if (paginationSet) {
      getItems(paginationSet.current, paginationSet.pageSize, filters_str)
    } else {
      getItems(1,  20, filters_str)
    }
  }

  function handleClearFilter() {
    setFilterState(null)
    if (pagination) {
      getItems(pagination.current, pagination.pageSize)
    } else {
      getItems()
    }
  }

  function formattedItems(items) {
    return items.map((item) => ({
      ...item,
      key: item.id
    }))
  }

  return {
    dataDiscounts,
    pagination,
    isLoading,
    handleTableChange,
    handleSearchTable,
    handleClearFilter,
    refetch: () => getItems(),
    options: { discountTypeOptions }
  }
}
